import React, { useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useAppModel } from "../appModel";

export function App() {
    const {
        loadData,
        resetState,
        loadDs,
    } = useAppModel()
    useEffect(() => {
        loadData({ pageNum: 1 }, {}).then()
        loadDs().then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

